(() => {

    useDashboardsNavFactory.$inject = ['$state', '$filter', 'hUser', 'brandServices', 'dashboardsPrerequisiteService', 'userPermissions'];

    function useDashboardsNavFactory($state, $filter, hUser, brandServices, dashboardsPrerequisiteService, userPermissions) {
        return function ($scope, isActiveLink, getBrandIds) {

            const sentimentDashboard = {
                title: $filter('translate')('Employee voice'),
                isActive: () => isActiveLink('appLayout.harriSH.dashboards.sentiment-engagement'),
                href: () => $state.href('appLayout.harriSH.dashboards.sentiment-engagement'),
                icon: {
                    unfilledSvg: '../images/svgs/sh-dashboards.svg',
                    filledSvg: '../images/svgs/sh-dashboards_filled.svg'
                },
                isVisible: async function () {
                    const brandIds = getBrandIds();

                    const [
                        isOnboardingJourneyEnabled,
                        isHarriEngageServiceEnabled
                    ] = await Promise.all([
                        brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, brandIds[0], true),
                        brandServices.check(brandServices.SERVICES.HARRI_ENGAGE, brandIds[0], true)
                    ]);

                    if (isOnboardingJourneyEnabled) {
                        this.title = $filter('translate')('Sentiment engagement');
                    }

                    return isOnboardingJourneyEnabled || isHarriEngageServiceEnabled;
                },
            };

            let isMainDashboardVisilbe = false;
            const mainDashboard = {
                title: $filter('translate')('Dynamic landing page'),
                isActive: () => {
                    return isActiveLink('appLayout.harriSH.dashboards.main-gp') || (isActiveLink('appLayout.harriSH.dashboards.main-parent') && isMainDashboardVisilbe && !isTlOnlyMainDashboardVisilble);
                },
                href: () => {
                    if (hUser.isTopLevelContext()) {
                        return $state.href('appLayout.harriSH.dashboards.main-gp');
                    } else {
                        return $state.href('appLayout.harriSH.dashboards.main-parent');
                    }
                },
                icon: {
                    unfilledSvg: '../images/svgs/sh-dashboards.svg',
                    filledSvg: '../images/svgs/sh-dashboards_filled.svg'
                },
                isVisible: async () => {
                    isMainDashboardVisilbe = await dashboardsPrerequisiteService.canViewHaloDashboard(hUser.getActiveBrandIdWithAccess());
                    return isMainDashboardVisilbe;
                },
            };

            let isTlOnlyMainDashboardVisilble;
            const tlOnlyMainDashboard = {
                ...mainDashboard,
                icon: {
                    unfilledSvg: '../images/svgs/sh-dashboards.svg',
                    filledSvg: '../images/svgs/sh-dashboards_filled.svg'
                },
                isActive: () => isActiveLink('appLayout.harriSH.dashboards.main-parent') && isTlOnlyMainDashboardVisilble,
                isVisible: async () => {
                    const [
                        policyParser,
                        canViewMainDashboard
                    ] = await Promise.all([
                        userPermissions.getBrandPolicy(hUser.getActiveBrandIdWithAccess()),
                        dashboardsPrerequisiteService.canViewHaloDashboard(hUser.getActiveBrandIdWithAccess())
                    ]);

                    isTlOnlyMainDashboardVisilble =
                        !policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) &&
                        policyParser.hasAccess(userPermissions.ACCESS_TYPES.TEAM) &&
                        !hUser.isHMAPUser() &&
                        canViewMainDashboard;
                    return isTlOnlyMainDashboardVisilble;
                }
            };

            const riskAnalysisDashboard = {
                title: $filter('translate')('Risk analysis'),
                isActive: () => isActiveLink('appLayout.harriSH.dashboards.risk'),
                href: () => $state.href('appLayout.harriSH.dashboards.risk'),
                icon: {
                    unfilledSvg: '../images/svgs/sh-dashboards.svg',
                    filledSvg: '../images/svgs/sh-dashboards_filled.svg'
                },
                isVisible: async () => {
                    const brandId = hUser.getActiveBrandIdWithAccess();
                    const riskDetectionService = brandServices.SERVICES.RISK_DETECTION;
                    const isRiskDashboardEnabled = await brandServices.check(riskDetectionService, brandId);

                    if (!isRiskDashboardEnabled) {
                        return false;
                    }

                    let response;
                    try {
                        response = await Promise.all([
                            dashboardsPrerequisiteService.canViewRiskDashboard(brandId),
                            ReportingSettingsManagementAPI.getServiceSettings(brandId, riskDetectionService)
                        ]);
                    } catch (e) {
                        console.error(e);
                        return false;
                    }

                    const [canViewRiskDashboard, riskServiceSettings] = response;

                    return (
                        canViewRiskDashboard &&
                        (
                            riskServiceSettings.location_filter_type === LOCATION_FILTER_TYPE.ALL_LEVELS ||
                            (
                                riskServiceSettings.location_filter_type === LOCATION_FILTER_TYPE.CHILDREN_ONLY &&
                                !hUser.isTopLevelContext()
                            )
                        )
                    );
                }
            };

            let tlRiskAnalysisDashboardIsVisible = false;
            const tlRiskAnalysisDashboard = {
                ...riskAnalysisDashboard,
                icon: {
                    unfilledSvg: '../images/svgs/sh-dashboards.svg',
                    filledSvg: '../images/svgs/sh-dashboards_filled.svg'
                },
                isVisible: async () => {
                    const activeBrandId = hUser.getActiveBrandIdWithAccess();
                    const [
                        policyParser,
                        canViewRiskDashboard
                    ] = await Promise.all([
                        userPermissions.getBrandPolicy(activeBrandId),
                        dashboardsPrerequisiteService.canViewRiskDashboard(activeBrandId)
                    ]);

                    tlRiskAnalysisDashboardIsVisible = (
                        !policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) &&
                        policyParser.hasAccess(userPermissions.ACCESS_TYPES.TEAM) &&
                        !hUser.isHMAPUser() &&
                        canViewRiskDashboard
                    );

                    return tlRiskAnalysisDashboardIsVisible;
                },
                isActive: () => isActiveLink('appLayout.harriSH.dashboards.risk') && tlRiskAnalysisDashboardIsVisible
            };

            const dashboardsNavItem = [{
                classNames: 'sb-main-items-container',
                search: {
                    enabled: true,
                    showInput: false,
                    term: ''
                },
                title: $filter('translate')('Enterprise dashboards'),
                icon: {
                    unfilledSvg: '../images/svgs/sh-dashboards.svg',
                    filledSvg: '../images/svgs/sh-dashboards_filled.svg'
                },
                isVisible: async () => {
                    const activeBrandId = hUser.getActiveBrandIdWithAccess();

                    const [
                        canViewCompaasDashboard,
                        canViewRiskDashboard,
                        canViewHaloDashboard,
                        canViewAdvancedOnboardingDashboard,
                        isOnboardingJourneyEnabled,
                        isHarriEngageServiceEnabled
                    ] = await Promise.all([
                        dashboardsPrerequisiteService.canViewCompaasDashboard(activeBrandId),
                        dashboardsPrerequisiteService.canViewRiskDashboard(activeBrandId),
                        dashboardsPrerequisiteService.canViewHaloDashboard(activeBrandId),
                        dashboardsPrerequisiteService.canViewAdvancedOnboardingDashboard(activeBrandId),
                        brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, activeBrandId, true),
                        brandServices.check(brandServices.SERVICES.HARRI_ENGAGE, activeBrandId, true)
                    ]);

                    return (
                        canViewCompaasDashboard ||
                        canViewRiskDashboard ||
                        canViewHaloDashboard ||
                        canViewAdvancedOnboardingDashboard ||
                        isOnboardingJourneyEnabled ||
                        isHarriEngageServiceEnabled
                    );
                },
                sections: [
                    {
                        items: [
                            mainDashboard,
                            {
                                ...sentimentDashboard
                            },
                            {
                                title: $filter('translate')('Other engagement'),
                                isActive: () => isActiveLink('appLayout.harriSH.dashboards.other-engagement'),
                                href: () => $state.href('appLayout.harriSH.dashboards.other-engagement'),
                                icon: {
                                    unfilledSvg: '../images/svgs/sh-dashboards.svg',
                                    filledSvg: '../images/svgs/sh-dashboards_filled.svg'
                                },
                                isVisible: async () => {
                                    const brandIds = getBrandIds();
                                    return await brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, brandIds[0], true);
                                },
                            },
                            {
                                title: $filter('translate')('Advanced onboarding'),
                                isActive: () => isActiveLink('appLayout.harriSH.dashboards.advanced-onboarding-overview'),
                                href: () => $state.href('appLayout.harriSH.dashboards.advanced-onboarding-overview'),
                                redirectToWorkspace: true,
                                icon: {
                                    unfilledSvg: '../images/svgs/sh-dashboards.svg',
                                    filledSvg: '../images/svgs/sh-dashboards_filled.svg'
                                },
                                isVisible: async () => {
                                    const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                    return await dashboardsPrerequisiteService.canViewAdvancedOnboardingDashboard(activeBrandId);
                                }
                            },
                            {
                                title: $filter('translate')('COMPaaS'),
                                isActive: () => isActiveLink('appLayout.harriSH.dashboards.compaas'),
                                href: () => $state.href('appLayout.harriSH.dashboards.compaas'),
                                icon: {
                                    unfilledSvg: '../images/svgs/sh-dashboards.svg',
                                    filledSvg: '../images/svgs/sh-dashboards_filled.svg'
                                },
                                isVisible: async () => {
                                    return await dashboardsPrerequisiteService.canViewCompaasDashboard(hUser.getActiveBrandIdWithAccess());
                                },
                            },
                            riskAnalysisDashboard,
                        ]
                    }
                ]
            }];

            const wfmDashboardsNav = [{
                classNames: 'sb-main-items-container',
                title: $filter('translate')('Dashboards'),
                isVisible: async () => {
                    const activeBrandId = hUser.getActiveBrandIdWithAccess();
                    const [
                        canViewCompaasDashboard,
                        canViewRiskDashboard,
                        canViewHaloDashboard,
                        isOnboardingJourneyEnabled,
                        isHarriEngageServiceEnabled
                    ] = await Promise.all([
                        dashboardsPrerequisiteService.canViewCompaasDashboard(activeBrandId),
                        tlRiskAnalysisDashboard.isVisible(),
                        tlOnlyMainDashboard.isVisible(),
                        brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, activeBrandId, true),
                        brandServices.check(brandServices.SERVICES.HARRI_ENGAGE, activeBrandId, true)
                    ]);

                    return (
                        canViewCompaasDashboard ||
                        canViewRiskDashboard ||
                        canViewHaloDashboard ||
                        (
                            !hUser.isHMAPUser() &&
                            (
                                isHarriEngageServiceEnabled ||
                                isOnboardingJourneyEnabled
                            )
                        )
                    );
                },
                sections: [
                    {
                        items: [
                            tlOnlyMainDashboard,
                            {
                                title: $filter('translate')('COMPaaS'),
                                icon: {
                                    unfilledSvg: '../images/svgs/sh-dashboards.svg',
                                    filledSvg: '../images/svgs/sh-dashboards_filled.svg'
                                },
                                isActive: () => isActiveLink('appLayout.schedule.tl-compaas-dashboard'),
                                href: () => $state.href('appLayout.schedule.tl-compaas-dashboard'),
                                isVisible: async () => {
                                    const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                    return await dashboardsPrerequisiteService.canViewCompaasDashboard(activeBrandId);
                                },
                            },
                            tlRiskAnalysisDashboard,
                            {
                                ...sentimentDashboard,
                                icon: {
                                    unfilledSvg: '../images/svgs/sh-dashboards.svg',
                                    filledSvg: '../images/svgs/sh-dashboards_filled.svg'
                                },
                                isVisible: async () => {
                                    const policyParser = await userPermissions.getBrandPolicy(hUser.getActiveBrandIdWithAccess());

                                    return (
                                        !hUser.isHMAPUser() &&
                                        !policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) &&
                                        await sentimentDashboard.isVisible()
                                    );
                                }
                            }
                        ]
                    }
                ]
            }];

            return {
                wfmDashboardsNav,
                dashboardsNavItem
            }
        }
    }

    angular
        .module("harriApp")
        .factory('useDashboardsNavFactory', useDashboardsNavFactory);
})();